import { intComma } from 'humanize-plus'
import React from 'react'

import {
  Box,
  Button,
  Flex,
  Icon,
  InputText 
} from '@driftt/dds'
import { faMagnifyingGlass } from '@driftt/dds.icons/dist/light/faMagnifyingGlass'

export const ContactListControls = ({
  totalContacts,
  onChange,
  showSegmentation 
}) => {
  return (
    <>
    <Box
      css={{ padding: '30px 30px 0 30px', }}
    >
      {`${intComma(totalContacts)} contacts`}
    </Box>
    <Flex
      justifyContent='flex-start'
      alignItems='center'
      gap={1}
      css={{
        padding: '0 30px',
        margin: '16px 0'
      }}
    >
      <InputText 
        size="medium"
        startAdornment={<Icon icon={faMagnifyingGlass} color="blue4" />}
        placeholder="Search..."
        hideLabel
        onChange={(event) => onChange(event)} 
      />
      <Button 
        variant="secondary"
        icon={'pb-filter'}
        onClick={() => showSegmentation()}
      >
          Create filter
      </Button>
    </Flex>
    </>
  )
}

export default ContactListControls
